<div class="header-close-button-row">
  <div class="header-content">
    <mat-icon class="header-icon">business</mat-icon>
    <h3>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.TITLE' | translate }}</h3>
  </div>
  <button mat-icon-button [matTooltip]="'ADMINISTRATION.DIALOGS.NEW_COMPANY.CLOSE_TOOLTIP' | translate"
    (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div class="progress-indicator">
  <span>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.PROGRESS' | translate }}: {{ progress }}%</span>
  <div class="progress-bar">
    <div class="progress-fill" [style.width.%]="progress"></div>
  </div>
</div>

<mat-stepper [linear]="true" [disableRipple]="true" #stepper>

  <mat-step [stepControl]="firstFormGroup">
    <ng-template matStepLabel>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_1.LABEL' | translate }}</ng-template>
    <form [formGroup]="firstFormGroup">
      <label>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_1.TITLE' | translate }}</label>

      <mat-form-field class="alim-mat-form-field alim-cif-field" appearance="outline">
        <mat-label>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_1.LEGAL_ID' | translate }}</mat-label>
        <input matInput formControlName="legalId"
          [placeholder]="'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_1.LEGAL_ID_PLACEHOLDER' | translate">
        <mat-error *ngIf="firstFormGroup.get('legalId')?.hasError('required')">
          {{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_1.LEGAL_ID_REQUIRED' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="alim-mat-form-field alim-legal-name-field" appearance="outline">
        <mat-label>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_1.LEGAL_NAME' | translate }}</mat-label>
        <input matInput formControlName="legalName"
          [placeholder]="'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_1.LEGAL_NAME_PLACEHOLDER' | translate">
        <mat-error *ngIf="firstFormGroup.get('legalName')?.hasError('required')">
          {{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_1.LEGAL_NAME_REQUIRED' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="alim-mat-form-field" appearance="outline">
        <mat-label>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_1.COUNTRY' | translate }}</mat-label>
        <mat-select formControlName="countryCode" class="alim-select-lengage">
          <mat-select-trigger>
            <span *ngIf="firstFormGroup.get('countryCode')?.value"
              [class]="'fi fi-' + firstFormGroup.get('countryCode')?.value.toLowerCase()"></span>
          </mat-select-trigger>
          <mat-option *ngFor="let country of countries" [value]="country.code">
            <span class="fi fi-{{ country.code?.toLowerCase() }}"></span> {{ country.name }}
          </mat-option>
        </mat-select>
        <mat-error>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_1.COUNTRY_REQUIRED' | translate }}</mat-error>
      </mat-form-field>

      <mat-form-field class="alim-mat-form-field" appearance="outline">
        <mat-label>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_1.NAME' | translate }}</mat-label>
        <input matInput formControlName="name"
          [placeholder]="'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_1.NAME_PLACEHOLDER' | translate">
        <mat-error *ngIf="firstFormGroup.get('name')?.hasError('required')">
          {{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_1.NAME_REQUIRED' | translate }}
        </mat-error>
        <mat-error *ngIf="firstFormGroup.get('name')?.hasError('minlength')">
          {{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_1.NAME_MIN_LENGTH' | translate }}
        </mat-error>
      </mat-form-field>


      <mat-form-field class="alim-mat-form-field" appearance="outline">
        <mat-label>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_1.LANGUAGE' | translate }}</mat-label>
        <mat-select formControlName="langCode" class="alim-select-lengage">
          <mat-select-trigger>
            <span *ngIf="firstFormGroup.get('langCode')?.value == 'ca'" [class]="'fi fi-es-ct'"></span>
            <span *ngIf="firstFormGroup.get('langCode')?.value == 'en'" [class]="'fi fi-gb'"></span>
            <span *ngIf="firstFormGroup.get('langCode')?.value == 'zh'" [class]="'fi fi-cn'"></span>
            <span
              *ngIf="firstFormGroup.get('langCode')?.value && firstFormGroup.get('langCode')?.value != 'ca' && firstFormGroup.get('langCode')?.value != 'en' && firstFormGroup.get('langCode')?.value != 'zh'"
              [class]="'fi fi-' + firstFormGroup.get('langCode')?.value.toLowerCase()"></span>
          </mat-select-trigger>
          <ng-container *ngFor="let lang of languages">
            <mat-option *ngIf="lang.isEnabledForFrontend" [value]="lang.code">
              <span *ngIf="lang.code == 'ca'" class="fi fi-es-ct"></span>
              <span *ngIf="lang.code == 'en'" class="fi fi-gb"></span>
              <span *ngIf="lang.code == 'zh'" class="fi fi-cn"></span>
              <span *ngIf="lang.code != 'ca' && lang.code != 'en' && lang.code != 'zh'"
                class="fi fi-{{ lang.code?.toLowerCase() }}"></span> {{ lang.name }}
            </mat-option>
          </ng-container>
        </mat-select>
        <mat-error>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_1.LANGUAGE_REQUIRED' | translate }}</mat-error>
      </mat-form-field>

      <mat-form-field class="alim-mat-form-field" appearance="outline">
        <mat-label>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_1.ROLES' | translate }}</mat-label>
        <mat-select formControlName="role" multiple>
          <mat-option *ngFor="let role of roles" [value]="role.value">
            {{ role.labelKey | translate }}
          </mat-option>
        </mat-select>
        <mat-error>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_1.ROLE_REQUIRED' | translate }}</mat-error>
      </mat-form-field>

      <div class="options-row">
        <div class="sync-options">
          <label>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_1.SYNC_OPTIONS_TITLE' | translate }}</label>
          <div class="sync-checkboxes">
            <mat-checkbox formControlName="syncWithV1">
              {{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_1.SYNC_WITH_V1' | translate }}
            </mat-checkbox>
            <mat-checkbox formControlName="enableAlignments">
              {{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_1.ENABLE_ALIGNMENTS' | translate }}
            </mat-checkbox>
          </div>
          <p class="info-text" *ngIf="firstFormGroup.get('syncWithV1')?.value">
            {{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_1.SYNC_V1_ALIGNMENTS_INFO' | translate }}
          </p>
        </div>

        <div class="sync-options">
          <label>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_1.DATA_OPTIONS_TITLE' | translate }}</label>
          <div class="sync-checkboxes">
            <mat-checkbox formControlName="canShareData">
              {{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_1.SHARE_DATA' | translate }}
            </mat-checkbox>

            <div *ngIf="firstFormGroup.get('canShareData')?.value" class="data-operator-suboption">
              <mat-checkbox formControlName="isDataOperator">
                {{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_1.DATA_OPERATOR' | translate }}
              </mat-checkbox>
              <p class="info-text">{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_1.DATA_OPERATOR_HINT' | translate }}</p>
            </div>

            <mat-checkbox formControlName="canConsumeData">
              {{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_1.QUERY_DATA' | translate }}
            </mat-checkbox>
          </div>
        </div>
      </div>

      <div class="product-languages-selector" *ngIf="enabledProductLanguages.length > 0">
        <label>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_1.PRODUCT_LANGUAGES_TITLE' | translate }}</label>
        <p class="info-text">{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_1.PRODUCT_LANGUAGES_INFO' | translate }}</p>

        <div class="languages-list">
          <mat-chip-set>
            <mat-chip-option *ngFor="let lang of enabledProductLanguages" [selected]="isLanguageSelected(lang)"
              (selectionChange)="toggleProductLanguage(lang)">
              <span *ngIf="lang.code == 'ca'" class="fi fi-es-ct"></span>
              <span *ngIf="lang.code == 'en'" class="fi fi-gb"></span>
              <span *ngIf="lang.code == 'zh'" class="fi fi-cn"></span>
              <span *ngIf="lang.code != 'ca' && lang.code != 'en' && lang.code != 'zh'"
                class="fi fi-{{ lang.code?.toLowerCase() }}"></span>
              {{ lang.name }}
            </mat-chip-option>
          </mat-chip-set>
        </div>

        <div *ngIf="selectedProductLanguages.length > 0" class="active-language-selector">
          <strong>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_1.PRODUCT_LANGUAGES_ACTIVE' | translate }}</strong>
          <div class="active-checkbox-group">
            <mat-checkbox *ngFor="let lang of selectedProductLanguages" [checked]="isLanguageActive(lang.code!)"
              (change)="toggleActiveProductLanguage(lang.code!)">
              <span *ngIf="lang.code == 'ca'" class="fi fi-es-ct"></span>
              <span *ngIf="lang.code == 'en'" class="fi fi-gb"></span>
              <span *ngIf="lang.code == 'zh'" class="fi fi-cn"></span>
              <span *ngIf="lang.code != 'ca' && lang.code != 'en' && lang.code != 'zh'"
                class="fi fi-{{ lang.code?.toLowerCase() }}"></span>
              {{ lang.name }}
            </mat-checkbox>
          </div>
        </div>

      </div>


      <div class="stepper-buttons">
        <button mat-button [disabled]="!firstFormGroup.valid" matStepperNext>
          <mat-icon>arrow_forward</mat-icon>
          {{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_1.NEXT' | translate }}
        </button>
      </div>
    </form>
  </mat-step>

  <mat-step [stepControl]="secondFormGroup">
    <ng-template matStepLabel>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.LABEL' | translate }}</ng-template>
    <form [formGroup]="secondFormGroup">
      <label>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.TITLE' | translate }}</label>

      <div class="organization-question">
        <label class="question-label">{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.BELONGS_TO_ORGANIZATION' |
          translate }}</label>
        <mat-radio-group formControlName="belongsToOrganization" class="organization-radio-group">
          <mat-radio-button value="yes">{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.YES' | translate
            }}</mat-radio-button>
          <mat-radio-button value="no">{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.NO' | translate
            }}</mat-radio-button>
        </mat-radio-group>
        <mat-error *ngIf="secondFormGroup.get('belongsToOrganization')?.hasError('required') && 
                          secondFormGroup.get('belongsToOrganization')?.touched">
          {{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.ORGANIZATION_CHOICE_REQUIRED' | translate }}
        </mat-error>
      </div>

      <div *ngIf="secondFormGroup.get('belongsToOrganization')?.value === 'yes'" class="organization-selector">

        <div class="search-with-button">
          <mat-form-field class="alim-mat-form-field search-field" appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.SELECT_ORGANIZATION' | translate }}</mat-label>
            <input matInput [(ngModel)]="organizationSearchText" [ngModelOptions]="{standalone: true}"
              (input)="filterOrganizations()" (keydown)="onOrganizationKeyDown($event)"
              [placeholder]="'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.ORGANIZATION_SEARCH_PLACEHOLDER' | translate">
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>

          <button mat-icon-button color="primary" (click)="toggleCreateOrganizationForm()"
            [attr.aria-label]="showCreateOrganizationForm ? ('ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.NO' | translate) : ('ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.CREATE_NEW_ORGANIZATION' | translate)"
            [matTooltip]="'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.CREATE_NEW_ORGANIZATION' | translate"
            matTooltipShowDelay="500">
            <mat-icon>{{ showCreateOrganizationForm ? 'close' : 'add' }}</mat-icon>
          </button>
        </div>

        <div *ngIf="showCreateOrganizationForm" class="create-organization-form">
          <h4>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.CREATE_NEW_ORGANIZATION' | translate }}</h4>
          <form [formGroup]="createOrganizationForm">
            <mat-form-field class="alim-mat-form-field" appearance="outline">
              <mat-label>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.ORGANIZATION_NAME' | translate }}</mat-label>
              <input matInput formControlName="name"
                [placeholder]="'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.ORGANIZATION_NAME_PLACEHOLDER' | translate">
              <mat-error *ngIf="createOrganizationForm.get('name')?.hasError('required')">
                {{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.FIELD_REQUIRED' | translate }}
              </mat-error>
              <mat-error *ngIf="createOrganizationForm.get('name')?.hasError('minlength')">
                {{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.MIN_LENGTH_3' | translate }}
              </mat-error>
            </mat-form-field>

            <mat-form-field class="alim-mat-form-field" appearance="outline">
              <mat-label>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_1.LEGAL_NAME' | translate }}</mat-label>
              <input matInput formControlName="legalName"
                [placeholder]="'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.LEGAL_NAME_PLACEHOLDER' | translate">
              <mat-error *ngIf="createOrganizationForm.get('legalName')?.hasError('required')">
                {{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.FIELD_REQUIRED' | translate }}
              </mat-error>
            </mat-form-field>

            <mat-form-field class="alim-mat-form-field" appearance="outline">
              <mat-label>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_1.LEGAL_ID' | translate }}</mat-label>
              <input matInput formControlName="legalId"
                [placeholder]="'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.LEGAL_ID_PLACEHOLDER' | translate">
              <mat-error *ngIf="createOrganizationForm.get('legalId')?.hasError('required')">
                {{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.FIELD_REQUIRED' | translate }}
              </mat-error>
            </mat-form-field>

            <mat-form-field class="alim-mat-form-field" appearance="outline">
              <mat-label>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_1.COUNTRY' | translate }}</mat-label>
              <mat-select formControlName="country" class="alim-select-lengage">
                <mat-select-trigger>
                  <span *ngIf="createOrganizationForm.get('country')?.value"
                    [class]="'fi fi-' + createOrganizationForm.get('country')?.value.toLowerCase()"></span>
                </mat-select-trigger>
                <mat-option *ngFor="let country of countries" [value]="country.code">
                  <span class="fi fi-{{ country.code?.toLowerCase() }}"></span> {{ country.name }}
                </mat-option>
              </mat-select>
              <mat-error>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.FIELD_REQUIRED' | translate }}</mat-error>
            </mat-form-field>

            <mat-form-field class="alim-mat-form-field" appearance="outline">
              <mat-label>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.EMAIL' | translate }}</mat-label>
              <input matInput formControlName="email" type="email"
                [placeholder]="'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.EMAIL_PLACEHOLDER' | translate">
              <mat-error *ngIf="createOrganizationForm.get('email')?.hasError('email')">
                {{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.EMAIL_INVALID' | translate }}
              </mat-error>
            </mat-form-field>

            <mat-form-field class="alim-mat-form-field" appearance="outline">
              <mat-label>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.PHONE' | translate }}</mat-label>
              <input matInput formControlName="phoneNumber"
                [placeholder]="'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.PHONE_PLACEHOLDER' | translate">
            </mat-form-field>

            <mat-form-field class="alim-mat-form-field" appearance="outline">
              <mat-label>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.WEBSITE' | translate }}</mat-label>
              <input matInput formControlName="website"
                [placeholder]="'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.WEBSITE_PLACEHOLDER' | translate">
            </mat-form-field>

            <mat-form-field class="alim-mat-form-field" appearance="outline">
              <mat-label>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.ADDRESS' | translate }}</mat-label>
              <textarea matInput formControlName="address" rows="2"
                [placeholder]="'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.ADDRESS_PLACEHOLDER' | translate"></textarea>
            </mat-form-field>

            <div class="form-buttons">
              <button mat-button type="button" (click)="toggleCreateOrganizationForm()">
                <mat-icon>close</mat-icon>
                {{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_1.CANCEL' | translate }}
              </button>
              <button mat-raised-button color="primary" type="button"
                [disabled]="!createOrganizationForm.valid || isCreatingOrganization" (click)="createOrganization()">
                <mat-icon>save</mat-icon>
                {{ isCreatingOrganization ? ('ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.CREATE_NEW_ORGANIZATION' |
                translate) : ('ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.CREATE_NEW_ORGANIZATION' | translate) }}
              </button>
            </div>
          </form>
        </div>

        <div class="organizations-list-container">

          <div *ngIf="isLoadingOrganizations" class="loading-organizations">
            <mat-spinner diameter="30"></mat-spinner>
            <span>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.SELECT_ORGANIZATION' | translate }}...</span>
          </div>

          <div *ngIf="!isLoadingOrganizations" class="organizations-list">
            <div *ngFor="let org of filteredOrganizations; let i = index" class="organization-item"
              [class.selected]="selectedOrganization?.id === org.id"
              [class.keyboard-selected]="selectedOrganizationIndex === i" (click)="selectOrganization(org)"
              (mouseenter)="onOrganizationMouseEnter(i)">

              <mat-icon class="check-icon" *ngIf="selectedOrganization?.id === org.id">
                check_circle
              </mat-icon>
              <mat-icon class="check-icon-placeholder" *ngIf="selectedOrganization?.id !== org.id">
                radio_button_unchecked
              </mat-icon>

              <div class="organization-info">
                <div class="organization-name">
                  {{ org.name || ('ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.NO_NAME' | translate) }}
                </div>
                <div class="organization-legal-name" *ngIf="org.legalName">
                  {{ org.legalName }}
                </div>
                <div class="organization-country" *ngIf="org.country">
                  <span class="fi fi-{{ org.country.toLowerCase() }}"></span> {{ org.country }}
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="filteredOrganizations.length === 0 && organizationSearchText && !isLoadingOrganizations"
            class="no-results">
            {{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.SELECT_ORGANIZATION' | translate }}
          </div>

          <div *ngIf="organizations.length === 0 && !organizationSearchText && !isLoadingOrganizations"
            class="no-results">
            {{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.SELECT_ORGANIZATION' | translate }}
          </div>
        </div>

        <mat-error *ngIf="secondFormGroup.get('organizationId')?.hasError('required') && 
                          secondFormGroup.get('organizationId')?.touched">
          {{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.ORGANIZATION_REQUIRED' | translate }}
        </mat-error>
      </div>

      <div class="stepper-buttons">
        <button mat-button matStepperPrevious [disabled]="createdCompanyId !== null">
          <mat-icon>arrow_back</mat-icon>
          {{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.BACK' | translate }}
        </button>
        <button mat-button [disabled]="!secondFormGroup.valid" matStepperNext>
          <mat-icon>arrow_forward</mat-icon>
          {{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_2.NEXT' | translate }}
        </button>
      </div>
    </form>
  </mat-step>

  <mat-step [stepControl]="thirdFormGroup">
    <ng-template matStepLabel>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_3.LABEL' | translate }}</ng-template>
    <form [formGroup]="thirdFormGroup">
      <label>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_3.TITLE' | translate }}</label>

      <div class="plan-filters" *ngIf="!isLoadingPlans && plans.length > 0">
        <mat-chip-set>
          <mat-chip-option *ngFor="let filter of profileFilters" [value]="filter.value"
            [selected]="selectedProfileFilter === filter.value" (click)="filterPlansByProfile(filter.value)">
            {{ filter.labelKey | translate }}
          </mat-chip-option>
        </mat-chip-set>
      </div>

      <div *ngIf="isLoadingPlans" class="loading-plans">
        <mat-spinner diameter="40"></mat-spinner>
        <span>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_3.SELECT_PLAN' | translate }}...</span>
      </div>

      <div *ngIf="!isLoadingPlans && filteredPlans.length > 0" class="plans-container">
        <mat-radio-group formControlName="planId" class="plans-radio-group">
          <div *ngFor="let plan of filteredPlans" class="plan-card"
            [class.selected]="thirdFormGroup.get('planId')?.value === plan.id" (click)="selectPlan(plan.id!)">

            <mat-radio-button [value]="plan.id"></mat-radio-button>

            <div class="plan-info">
              <div class="plan-header">
                <span class="plan-name">{{ plan.name }}</span>

              </div>
              <span class="plan-profile" *ngIf="plan.profile"
                [class.profile-hunter]="plan.profile.toLowerCase() === 'hunter'"
                [class.profile-deliver]="plan.profile.toLowerCase() === 'deliver'"
                [class.profile-hunter_deliver]="plan.profile.toLowerCase() === 'hunter_deliver'"
                [class.profile-eb2b]="plan.profile.toLowerCase() === 'eb2b'"
                [class.profile-custom]="plan.profile.toLowerCase() === 'custom'">
                {{ plan.profile }}
              </span>
            </div>
          </div>
        </mat-radio-group>
      </div>

      <div *ngIf="!isLoadingPlans && filteredPlans.length === 0 && plans.length > 0" class="no-plans">
        <mat-icon>filter_list_off</mat-icon>
        <p>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_3.ALL_PLANS' | translate }}</p>
        <button mat-button color="primary" (click)="filterPlansByProfile('all')">
          <mat-icon>clear</mat-icon>
          {{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_3.ALL_PLANS' | translate }}
        </button>
      </div>

      <div *ngIf="!isLoadingPlans && plans.length === 0" class="no-plans">
        <mat-icon>info</mat-icon>
        <p>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_3.ALL_PLANS' | translate }}</p>
      </div>

      <div class="stepper-buttons">
        <button mat-button matStepperPrevious [disabled]="createdCompanyId !== null">
          <mat-icon>arrow_back</mat-icon>
          {{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_3.BACK' | translate }}
        </button>
        <button mat-button [disabled]="!thirdFormGroup.valid || isAssigningPlan" (click)="startCompanyOnboarding()">
          <mat-icon>arrow_forward</mat-icon>
          {{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_3.NEXT' | translate }}
        </button>
      </div>
    </form>
  </mat-step>

  <mat-step>
    <form class="channels-form">
      <ng-template matStepLabel>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_4.LABEL' | translate }}</ng-template>
      <label>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_4.TITLE' | translate }}</label>

      <div *ngIf="isLoadingChannels && channelsB2B.length === 0">
        <mat-spinner diameter="40"></mat-spinner>
        <span>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_4.LOADING' | translate }}</span>
      </div>

      <div *ngIf="!isLoadingChannels || channelsB2B.length > 0" (scroll)="onChannelsScroll($event)">
        <div class="channels-list-container">
          <mat-card *ngFor="let channel of channelsB2B">
            <mat-card-header>
              <mat-card-title>{{ channel.name }}</mat-card-title>
              <mat-card-subtitle *ngIf="channel.type">{{ channel.type }}</mat-card-subtitle>
            </mat-card-header>

            <mat-card-actions align="end">
              <button mat-button (click)="joinChannel(channel)"
                [disabled]="!createdCompanyId || channel.isJoining || channel.isJoined">
                <mat-icon *ngIf="!channel.isJoining && !channel.isJoined">add_circle</mat-icon>
                <mat-icon *ngIf="channel.isJoining">hourglass_empty</mat-icon>
                <mat-icon *ngIf="channel.isJoined">check_circle</mat-icon>
                {{ channel.isJoining ? ('ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_4.LOADING' | translate) :
                (channel.isJoined ? ('ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_4.JOINED' | translate) :
                ('ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_4.JOIN' | translate)) }}
              </button>
            </mat-card-actions>
          </mat-card>
        </div>

        <div *ngIf="isLoadingChannels && channelsB2B.length > 0" class="loading-more-channels">
          <mat-spinner diameter="30"></mat-spinner>
          <span>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_4.LOADING' | translate }}</span>
        </div>
      </div>

      <div *ngIf="!isLoadingChannels && channelsB2B.length === 0" class="no-channels">
        <mat-icon>info</mat-icon>
        <p>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_4.NO_CHANNELS' | translate }}</p>
      </div>

      <div class="stepper-buttons">
        <button mat-button matStepperPrevious [disabled]="createdCompanyId !== null">
          <mat-icon>arrow_back</mat-icon>
          {{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_4.BACK' | translate }}
        </button>
        <button mat-button matStepperNext>
          <mat-icon>arrow_forward</mat-icon>
          {{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_4.NEXT' | translate }}
        </button>
      </div>
    </form>
  </mat-step>

  <mat-step [stepControl]="fifthFormGroup">
    <ng-template matStepLabel>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_5.LABEL' | translate }}</ng-template>
    <form [formGroup]="fifthFormGroup">
      <label>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_5.TITLE' | translate }}</label>

      <div class="invite-choice">
        <label>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_5.QUESTION' | translate }}</label>
        <mat-radio-group formControlName="inviteChoice" class="invite-choice-group">
          <mat-radio-button value="yes">{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_5.YES' | translate
            }}</mat-radio-button>
          <mat-radio-button value="no">{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_5.NO' | translate
            }}</mat-radio-button>
        </mat-radio-group>
      </div>

      <ng-container *ngIf="fifthFormGroup.get('inviteChoice')?.value === 'yes'">
        <p class="info-text">
          {{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_5.INFO_TEXT' | translate }}
        </p>

        <div style="grid-column: 1 / -1;">
          <mat-form-field class="alim-mat-form-field" appearance="outline">
            <mat-label>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_5.EMAIL' | translate }}</mat-label>
            <textarea matInput formControlName="emails" rows="8"
              [placeholder]="'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_5.EMAILS_PLACEHOLDER' | translate"
              (paste)="onEmailsPaste($event)">
          </textarea>
            <mat-hint>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_5.EMAILS_HINT' | translate }}</mat-hint>
            <mat-error *ngIf="fifthFormGroup.get('emails')?.hasError('invalidEmails')">
              {{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_5.INVALID_EMAILS' | translate }}
            </mat-error>
          </mat-form-field>
        </div>



        <div *ngIf="emailsList.length > 0" class="emails-preview">
          <h4>{{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_5.EMAIL' | translate }} ({{ emailsList.length }})</h4>
          <div class="emails-chips">
            <mat-chip-set>
              <mat-chip *ngFor="let email of emailsList; let i = index" [removable]="true" (removed)="removeEmail(i)">
                {{ email }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
            </mat-chip-set>
          </div>
        </div>
      </ng-container>

      <div class="stepper-buttons">
        <button mat-button matStepperPrevious>
          <mat-icon>arrow_back</mat-icon>
          {{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_5.BACK' | translate }}
        </button>

        <ng-container *ngIf="fifthFormGroup.get('inviteChoice')?.value === 'no'; else inviteActions">
          <button mat-button [disabled]="isInvitingUsers" (click)="finishWithoutInvites()">
            <mat-icon>check_circle</mat-icon>
            {{ 'ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_5.NO_INVITES' | translate }}
          </button>
        </ng-container>

        <ng-template #inviteActions>
          <button mat-button [disabled]="isInvitingUsers || fifthFormGroup.invalid || emailsList.length === 0"
            (click)="inviteUsers()">
            <mat-icon>send</mat-icon>
            {{ isInvitingUsers ? ('ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_5.LOADING' | translate) :
            ('ADMINISTRATION.DIALOGS.NEW_COMPANY.STEP_5.SEND_INVITES' | translate) }}
          </button>
        </ng-template>
      </div>
    </form>
  </mat-step>

</mat-stepper>
